var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisagreeIconFilledd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1793 25.9618L21.8541 18.3679C22.3676 17.8607 22.6591 17.1616 22.6591 16.4352V2.74148C22.6591 1.23366 21.41 0 19.8834 0H7.40666C6.29639 0 5.29714 0.657955 4.86691 1.65859L0.342539 12.0899C-0.837128 14.804 1.17524 17.8196 4.15911 17.8196H12.0004L10.682 24.0976C10.5432 24.783 10.7514 25.482 11.251 25.9755C12.0698 26.7705 13.3744 26.7705 14.1793 25.9618V25.9618ZM28.2243 0C26.6977 0 25.4486 1.23366 25.4486 2.74148V13.7074C25.4486 15.2152 26.6977 16.4489 28.2243 16.4489C29.7509 16.4489 31 15.2152 31 13.7074V2.74148C31 1.23366 29.7509 0 28.2243 0Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisagreeIconFilledd);
export default __webpack_public_path__ + "static/media/disagree-icon-filledd.c3f170c65eb56b6594423bfab26d0301.svg";
export { ForwardRef as ReactComponent };